import { ServicePill } from '@/components/ui/service-pill';
import { useGetAllServicesQuery } from '../../../orders/services/orderApi';
import { getOrderedServices } from '../utils/propertyListUtils';
import type { ServicesOrderedModel } from './servicesOrderedModel';

// Orders-table "Services Ordered" cell. Current services render as soft-tint
// category pills with quantity (DV-417). The UTC badge (DV-2208) lives in the
// Order Status cell since DV-3535. When a service the customer originally
// ordered is no longer present, the originals render beneath as muted,
// struck-through pills (DV-496). The product catalog (category + quantity
// decision) is fetched once via a cached RTK Query shared by every row.
export function ServicesOrderedCell({
  model
}: {
  model: ServicesOrderedModel;
}) {
  const { data: catalog } = useGetAllServicesQuery();
  const current = getOrderedServices(model.currentServices, catalog);
  const original =
    model.showOriginal && model.originalServices
      ? getOrderedServices(model.originalServices, catalog)
      : [];

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-wrap items-start gap-1.5">
        {current.length === 0 ? (
          <span className="text-muted-foreground">-</span>
        ) : (
          current.map((item, index) => (
            <ServicePill
              key={`${item.name}-${index}`}
              category={item.category}
              quantity={item.quantity}
            >
              {item.name}
            </ServicePill>
          ))
        )}
      </div>
      {original.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {original.map((item, index) => (
            <ServicePill
              key={`original-${item.name}-${index}`}
              category={item.category}
              removed
            >
              {item.name}
            </ServicePill>
          ))}
        </div>
      )}
    </div>
  );
}
